<template>
    <div>
        <div class="seachBox flex">

            <div class="seachList"><span class="name">关键字：</span>
                <a-input placeholder="" class="seachs" v-model="seach.name"/>
            </div>
            <div class="seachList  ">   <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button> </div>

            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <div  >
            <a-button class="top_btn" type="primary" @click=" exper">
                导出
            </a-button>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
             <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false"/>
      </span>
            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visible = true;; title='修改分类'; editId=text.id ; }">编辑</a>
                 <a-divider type="vertical"/>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a>删除</a>
  </a-popconfirm>
      </span>
        </a-table>

    </div>
</template>

<script>
    import API from "../api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../../../utils/utils"
    const columns = [
        {
            title: "公司名称",
            dataIndex: "name",
            key: "name",
            width: "120px",
        },
        {
            title: "联系人",
            dataIndex: "person",
            ellipsis: true,
            width: "150px",
            key: "person",
        },
        {
            title: "电话",
            dataIndex: "phone",
            ellipsis: true,
            width: "150px",
            key: "phone",
        },
        {
            title: "网址",
            key: "url",
            dataIndex: "url",
            width: "150px",
        }
    ];
    export default {
        name: "google",
        data() {
            return {
                seach: {
                    name: "",
                },
                name:"",
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/AdvertisingRecords"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            exper(id) {
                API.google.EXPORT({name:this.name ,ids:this.selectedRowKeys}).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.substr(1)}`  )
                    // this.getList()
                    this.selectedRowKeys = []
                })
            },
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                API.google.LIST_ORDER(list_orders).then(res => {
                    this.getList()
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    name: "",
                }
                this.getList(1)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))
                this.name=this.seach.name
                API.google.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },

        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
